//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CesHttpClient, Continuum } from "../CesHttpClient";
import Plotly from "plotly.js";
import { mapState } from "vuex";

const axios = require("axios");

export default {
  props: {
    httpClient: {
      type: CesHttpClient,
      default: null
    }
  },
  data: function () {
    return {
      cesModel: null,
      title: "Default title",
      content: "index.html", // Default value
      index: "",
      img: ""
    };
  },
  mounted: function () {
    //console.log("Mounted !!");
    this.img = this.httpClient.getServerURL() + "/web/eye1.png";
    this.updateContent();

    /*
    const TESTER = document.getElementById("tester");
    Plotly.plot(
      TESTER,
      [
        {
          x: [1,  5],
          y: [1, 16],
          z: [ [1,2,3], [4,5,6], [7,8,9], [3,3,2],[2,5,3]  ],
          type: "heatmapgl", 
          zsmooth: "false", 
          colorscale: "Picnic"
          
        }
      ],
      {
        margin: { t: 0 }
      }
    ); 
    */
  },
  computed: {
    ...mapState({
      scenarioJSON: state => state.preferences.scenarioJSON
    })
  },
  methods: {
    init: function () {
      //console.log("Init !!");
    },
    updateContent: async function () {
      if (
        "cesModel" in this.scenarioJSON &&
        "info" in this.scenarioJSON.cesModel
      ) {
        const info = this.scenarioJSON.cesModel.info;
        this.title = info.title;
        console.log(info)
        this.img = this.httpClient.getServerURL() + "/GSTS/web/" + info.img;

        const html = await axios
          .get(this.httpClient.getServerURL() + "/GSTS/web/" + info.content)
          .then(function (response) {
            return response.data;
          })
          .catch(function (error) {
            console.log(error);
            return Promise.reject(error);
          });
        if (html != null) this.index = html;
      }
    }
  },
  watch: {
    scenarioJSON: {
      handler: function (val, oldVal) {
        this.updateContent();
      },
      deep: true
    }
  }
};
